// Broadsheet (LOOKS.md Part 6 and 9): the matchup as a newspaper box score —
// newsprint, serif headlines, ink rules instead of boxes, one spot color.
// From its artboard, docs/design/mockups/looks/Broadsheet.dc.html and
// H2H-Broadsheet.dc.html. Dark mode is the night edition: the same page
// printed in light ink on dark stock.

import { defineLook } from '../define';
import './look.css';

export default defineLook({
  id: 'broadsheet',
  label: 'Broadsheet',
  blurb: 'A newspaper box score: newsprint, serif headlines and ink rules.',
  order: 2,
  grounds: {
    light: {
      'bg-canvas': '#f4efe3',
      'bg-surface': '#f4efe3',
      'bg-raised': '#faf7ef',
      'bg-sunken': '#ebe4d4',
      'border-subtle': '#d4ccbd',
      'border-strong': '#1a1714',
      'ink-primary': '#1a1714',
      'ink-secondary': '#5c554b',
      'ink-muted': '#7d7568',
      // The spot color: the artboard's red, for what is live and what is lost.
      live: '#9b1c1c',
      loss: '#9b1c1c',
      win: '#2d6a4f',
    },
    dark: {
      'bg-canvas': '#16140f',
      'bg-surface': '#16140f',
      'bg-raised': '#1e1b15',
      'bg-sunken': '#100e0b',
      'border-subtle': '#3a352c',
      'border-strong': '#efe8d8',
      'ink-primary': '#efe8d8',
      'ink-secondary': '#b3aa99',
      'ink-muted': '#8f8778',
      live: '#e2574c',
      loss: '#e2574c',
      win: '#7cc39b',
    },
  },
  fonts: () =>
    Promise.all([
      import('@fontsource/playfair-display/700.css'),
      import('@fontsource/playfair-display/800.css'),
      import('@fontsource/playfair-display/900.css'),
      import('@fontsource/source-serif-4/400.css'),
      import('@fontsource/source-serif-4/400-italic.css'),
      import('@fontsource/source-serif-4/600.css'),
      import('@fontsource/libre-franklin/400.css'),
      import('@fontsource/libre-franklin/500.css'),
      import('@fontsource/libre-franklin/600.css'),
      import('@fontsource/libre-franklin/700.css'),
      import('@fontsource/libre-franklin/800.css'),
    ]),
});
